import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
};

export const deliveryUserReducer = createReducer(initialState, {
  LoadDeliveryUserRequest: (state) => {
    state.loading = true;
  },
  LoadDeliveryUserSuccess: (state, action) => {
    state.isAuthenticated = true;
    state.loading = false;
    state.deliveryUser = action.payload;
  },
  LoadDeliveryUserFail: (state, action) => {
    state.loading = false;
    state.error = action.payload || "Api Not Found";
    state.isAuthenticated = false;
  },

  // update Delivery user information
  updateDeliveryUserInfoRequest: (state) => {
    state.loading = true;
  },
  updateDeliveryUserInfoSuccess: (state, action) => {
    state.loading = false;
    state.deliveryUser = action.payload;
  },
  updateDeliveryUserInfoFailed: (state, action) => {
    state.loading = false;
    state.error = action.payload;
  },

  // update delivery user address
  updateDeliveryUserAddressRequest: (state) => {
    state.addressloading = true;
  },
  updateDeliveryUserAddressSuccess: (state, action) => {
    state.addressloading = false;
    state.successMessage = action.payload.successMessage;
    state.deliveryUser = action.payload.deliveryUser;
  },
  updateDeliveryUserAddressFailed: (state, action) => {
    state.addressloading = false;
    state.error = action.payload;
  },

  // delete delivery user address
  deleteDeliveryUserAddressRequest: (state) => {
    state.addressloading = true;
  },
  deleteDeliveryUserAddressSuccess: (state, action) => {
    state.addressloading = false;
    state.successMessage = action.payload.successMessage;
    state.deliveryUser = action.payload.deliveryUser;
  },
  deleteDeliveryUserAddressFailed: (state, action) => {
    state.addressloading = false;
    state.error = action.payload;
  },

  // get all delivery users --- admin
  getAllDeliveryUsersRequest: (state) => {
    state.deliveryUersLoading = true;
  },
  getAllDeliveryUsersSuccess: (state,action) => {
    state.deliveryUsersLoading = false;
    state.deliveryUsers = action.payload;
  },
  getAllDeliveryUsersFailed: (state,action) => {
    state.deliveryUsersLoading = false;
    state.error = action.payload;
  },
  clearErrors: (state) => {
    state.error = null;
  },
  clearMessages: (state) => {
    state.successMessage = null;
  },
});
